var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-wrap"},[_c('div',{staticClass:"line-info",class:{ fault: _vm.getStatus},on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.lineInfo.라인명)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }